import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function CtaBanner({ title, description, ctaLabel, testid, topPadding = true }) {
  return (
    <section className={`container-x pb-24 md:pb-32 ${topPadding ? "pt-16" : ""}`}>
      <div className="rounded-2xl bg-gradient-to-br from-[#152521] via-[#0E1311] to-[#1F1410] text-white p-10 md:p-14 flex flex-col md:flex-row md:items-center justify-between gap-6 border border-border">
        <div>
          <h3 className="font-display text-3xl md:text-4xl tracking-tight max-w-2xl">{title}</h3>
          {description && <p className="mt-3 text-white/70">{description}</p>}
        </div>
        <Link
          to="/contact"
          data-testid={testid}
          className="inline-flex items-center gap-2 px-6 py-3.5 rounded-md bg-[hsl(var(--accent))] text-white font-medium hover:bg-[#c84d2e] transition-colors shrink-0"
        >
          {ctaLabel} <ArrowUpRight className="h-4 w-4" />
        </Link>
      </div>
    </section>
  );
}
